import Immutable from 'immutable';

import type ErrorData from 'sharedreact/data/ErrorData';
import AppDispatcher from 'sharedreact/dispatcher/AppDispatcher';

import UsageConnection from 'workspaces/launcher/connections/UsageConnection';
import UsageConstants from 'workspaces/launcher/constants/UsageConstants';

function _fetchSuccess (status: Immutable.Map<string, any>) {
  AppDispatcher.dispatch({
    actionType: UsageConstants.GET_SUCCESS,
    didOptIn: status.get('enabled'),
    userName: status.get('eskoID'),
    testEnv: status.get('testEnv'),
    logLevel: 'debug'
  });
}

function _fetchFailure (error: ErrorData) {
  AppDispatcher.dispatch({
    actionType: UsageConstants.GET_FAIL,
    error: error,
    logLevel: 'debug'
  });
}

function fetch () {
  UsageConnection.fetch(_fetchSuccess, _fetchFailure);
}

function _optInFailure (error: ErrorData) {
  AppDispatcher.dispatch({
    actionType: UsageConstants.OPT_IN_FAIL,
    error: error,
    logLevel: 'debug'
  });
}

function _optInSuccess (status: Immutable.Map<string, any>) {
  AppDispatcher.dispatch({
    actionType: UsageConstants.OPT_IN_SUCCESS,
    didOptIn: status.get('enabled'),
    userName: status.get('eskoID'),
    testEnv: status.get('testEnv'),
    logLevel: 'debug'
  });
}

function optIn (userName: string, password: string) {
  UsageConnection.optIn(userName, password, _optInSuccess, _optInFailure)
}

function _optOutSuccess (status: Immutable.Map<string, any>) {
  AppDispatcher.dispatch({
    actionType: UsageConstants.OPT_OUT_SUCCESS,
    didOptIn: status.get('enabled'),
    userName: status.get('eskoID'),
    testEnv: status.get('testEnv'),
    logLevel: 'debug'
  });
}

function _optOutFailure (error: ErrorData) {
  AppDispatcher.dispatch({
    actionType: UsageConstants.OPT_OUT_FAIL,
    error: error,
    logLevel: 'debug'
  });
}

function optOut (keepData: boolean) {
  UsageConnection.optOut(keepData, _optOutSuccess, _optOutFailure);
}

const UsageActions = {
  fetch,
  optIn,
  optOut
};

export default UsageActions;